export default __webpack_public_path__ + "static/media/classroom_setting.e211cadd.jpg";